import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Grid, Row, Col, Table, ProgressBar, Alert, Button } from "react-bootstrap";
import { object, func } from "prop-types";
import axios from "axios";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { uploadFile } from "../utils/uploadFile";
import moment from "moment";
import _ from "lodash";
import SMSSendingModal from "./modals/SMSSendingModal";
import ExportSendingModal from "./modals/ExportSendingModal";

import { updateVideo } from "../actions";

import config from "../config";
import { getAuthToken } from "../utils/sessionStorage";
import { get } from "../utils/apiService";
import ExpirationDateModal from "./modals/ExpirationDateModal";
import DatePicker from "react-datepicker";

class CampaignSending extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tagInput: "",
      fileInput: "",
      newSendingExpirationDate: moment().add(20, "days"),
      submitting: false,
      done: false,
      tags: [],
      error: "",
      showSMSSendingModal: false,
      showExportSendingModal: false,
      showExpirationDateModal: false,
      sendingId: 0
    };

    this.submitUpload = this.submitUpload.bind(this);
    this.updateVideo = this.updateVideo.bind(this);
    this.sendingStatus = this.sendingStatus.bind(this);
    this.verifyTag = this.verifyTag.bind(this);
    this.loadTags = this.loadTags.bind(this);
    this.resetInputs = this.resetInputs.bind(this);
    this.refreshVideo = this.refreshVideo.bind(this);

    // SMS Sending Modal
    this.openSMSSendingModal = this.openSMSSendingModal.bind(this);
    this.closeSMSSendingModal = this.closeSMSSendingModal.bind(this);

    // Export Sending Modal
    this.openExportSendingModal = this.openExportSendingModal.bind(this);
    this.closeExportSendingModal = this.closeExportSendingModal.bind(this);

    // Expiration Date Modal
    this.openExpirationDateModal = this.openExpirationDateModal.bind(this);
    this.closeExpirationDateModal = this.closeExpirationDateModal.bind(this);

    this.handleChaneNewSendingExpirationDate = this.handleChaneNewSendingExpirationDate.bind(this);
  }

  handleChaneNewSendingExpirationDate(date) {
    this.setState({
      newSendingExpirationDate: date
    });

    console.log(this.state);
  }
  componentWillMount() {
    this.loadTags();
    this.refreshVideo();
  }
  loadTags() {
    let { video } = this.props;
    let url = `/campaigns/${video.campaign_id}/filters`;
    get(url).then(res => {
      this.setState({
        tags: res.data
      });
    });
  }
  verifyTag() {
    let tagInput = this.tagInput.value;
    if (_.includes(this.state.tags, tagInput)) {
      this.setState({ error: "Já existe uma tag com esse nome" });
      return false;
    }
    this.setState({ error: "" });
    return true;
  }
  submitUpload() {
    let tagIsAllowed = this.verifyTag();
    if (!tagIsAllowed) {
      return;
    }
    this.setState({ submitting: true });
    const { video } = this.props;
    let file = this.filesInput.files[0];
    if (file) {
      uploadFile(file, video)
        .then(res => {
          let fileUrl = res;
          this.updateVideo(fileUrl);
        })
        .catch(err => {
          this.setState({ submitting: false });
        });
    } else {
      toastr.error("Nenhum arquivo para fazer upload");
      this.setState({ submitting: false });
    }
  }
  updateVideo(fileUrl) {
    let tagInput = this.tagInput.value;
    const { video, updateVideo } = this.props;
    let url = `${config.url}/campaigns/${video.campaign_id}/videos/${video.id}/sendings`;
    let data = {
      data_path: fileUrl,
      sending_tag: tagInput,
      expiration_date: this.state.newSendingExpirationDate
    };
    axios({
      method: "POST",
      url: url,
      headers: { "X-User-Token": getAuthToken() },
      data: data
    })
      .then(res => {
        let updatedVideo = res.data;
        updateVideo(video.campaign_id, updatedVideo);
        toastr.success("Novo sending cadastrado com sucesso!");
        this.setState({ done: true });
        this.loadTags();
      })
      .catch(err => {
        toastr.error("Ocorreu um erro. Tente novamente!");
      });
  }
  resetInputs() {
    this.tagInput.value = "";
    this.filesInput.value = "";
  }
  sendingStatus(status) {
    switch (status) {
      case "created":
        return <span className="text-info">Em análise</span>;
      case "approved":
        return <span className="text-warning">Produzindo Urls</span>;
      case "rejected":
        return <span className="text-danger">Base inválida</span>;
      case "done":
        return <span className="text-success">Concluído</span>;
      default:
        break;
    }
  }
  openExportSendingModal() {
    this.setState({ showExportSendingModal: true });
  }
  closeExportSendingModal() {
    this.setState({ showExportSendingModal: false });
  }
  openSMSSendingModal() {
    this.setState({ showSMSSendingModal: true });
  }
  closeSMSSendingModal() {
    this.setState({ showSMSSendingModal: false });
  }
  openExpirationDateModal() {
    this.setState({ showExpirationDateModal: true });
  }
  closeExpirationDateModal() {
    this.setState({ showExpirationDateModal: false });
  }
  refreshVideo() {
    toastr.info("Atualizando video");
    const { video, updateVideo } = this.props;
    let url = `${config.url}/campaigns/${video.campaign_id}/videos/${video.id}`;
    axios({
      method: "GET",
      url: url,
      headers: { "X-User-Token": getAuthToken() }
    })
      .then(res => {
        let updatedVideo = res.data;
        updateVideo(video.campaign_id, updatedVideo);
        toastr.success("Video atualizado com sucesso!");
      })
      .catch(err => {
        toastr.error("Ocorreu um erro. Tente novamente!");
      });
  }
  render() {
    const { video } = this.props;
    let sendings;
    try {
      sendings = video.sendings.slice(0);
    } catch (err) {
      sendings = [];
    }
    sendings = sendings.reverse();
    return (
      <Grid>
        {this.state.error !== "" && (
          <Row>
            <Col md={12}>
              <Alert bsStyle="warning">{this.state.error}</Alert>
            </Col>
          </Row>
        )}
        <Row className={this.state.submitting || this.state.done ? "hidden" : ""}>
          <Col md={4}>
            <div className="form-group">
              <label>Tag</label>
              <input
                name="tag"
                className="form-control"
                type="text"
                ref={input => {
                  this.tagInput = input;
                }}
              />
            </div>
          </Col>

          <Col md={5}>
            <div>
              <div className="form-group">
                <label>Upload de arquivo:</label>
                <input
                  tag="file"
                  className="form-control"
                  type="file"
                  ref={input => {
                    this.filesInput = input;
                  }}
                />
              </div>
            </div>
          </Col>

          <Col md={2}>
            <div className="form-group">
              <label>Data de expiração</label>
              <DatePicker
                selected={this.state.newSendingExpirationDate}
                onChange={this.handleChaneNewSendingExpirationDate}
                minDate={moment().add(1, "days")}
                className="form-control"
              />
              <small>
                <b className="text-danger">Atenção!</b> A data de expiração <b>não</b> poderá ser alterada depois.
              </small>
            </div>
          </Col>

          <Col md={1}>
            <Button style={{ marginTop: "25px" }} onClick={this.submitUpload}>
              Enviar
            </Button>
          </Col>
        </Row>
        <Row className={this.state.submitting || this.state.done ? "" : "hidden"}>
          <Col md={12}>
            <div className={this.state.submitting && !this.state.done ? "" : "hidden"}>
              <ProgressBar active now={100} label="Fazendo upload..." />
            </div>
            <div style={{ overflow: "hidden" }} className={this.state.done ? "mb20" : "hidden"}>
              <p style={{ float: "left" }}>Novo envio carregado com sucesso!</p>
              <button
                className="btn btn-sm btn-primary pull-right ml10"
                onClick={() => {
                  this.setState({ done: false, submitting: false });
                  this.resetInputs();
                }}
              >
                Enviar outro arquivo
              </button>
              <Link to={`/campaigns/${video.campaign_id}/videos`}>
                <button className="btn btn-sm btn-default pull-right">Voltar</button>
              </Link>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <button onClick={this.refreshVideo}>Atualizar</button>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Table bordered striped className="mt20">
              <thead>
                <tr>
                  <th style={{ width: "15%" }}>Sending ID</th>
                  <th style={{ width: "15%" }}>Data de criação</th>
                  <th style={{ width: "15%" }}>Data de expiração</th>
                  <th style={{ width: "15%" }}>Tag</th>
                  <th style={{ width: "5%" }}>Status</th>
                  <th style={{ width: "5%" }} />
                  <th style={{ width: "5%" }} />
                  <th style={{ width: "5%" }} />
                </tr>
              </thead>
              <tbody>
                {sendings.map((sending, index) => (
                  <tr key={sending.id}>
                    <td style={{ verticalAlign: "middle" }}>{sending.id}</td>
                    <td style={{ verticalAlign: "middle" }}>{moment(sending.created_at).format("LLL")}</td>
                    <td style={{ verticalAlign: "middle" }}>
                      {sending.expiration_date != null ? moment(sending.expiration_date).format("LLL") : "-"}
                    </td>
                    <td style={{ verticalAlign: "middle" }}>{sending.sending_tag}</td>
                    <td style={{ verticalAlign: "middle" }}>{sending.status}</td>
                    <td>
                      <a className="btn btn-link btn-sm" href={sending.data_path} download>
                        Visualizar
                      </a>
                    </td>
                    <td>
                      <a
                        className="btn btn-link btn-sm"
                        onClick={() => {
                          this.setState({ sendingId: sending.id });
                          this.openExportSendingModal();
                        }}
                      >
                        Exportar
                      </a>
                    </td>
                    <td>
                      <a
                        className="btn btn-link btn-sm"
                        onClick={() => {
                          this.setState({ sendingId: sending.id });
                          this.openSMSSendingModal();
                        }}
                      >
                        Enviar SMS
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Col>
        </Row>
        <SMSSendingModal
          show={this.state.showSMSSendingModal}
          close={this.closeSMSSendingModal}
          sendingId={this.state.sendingId}
          video={video}
        />
        <ExportSendingModal
          show={this.state.showExportSendingModal}
          close={this.closeExportSendingModal}
          sendingId={this.state.sendingId}
          video={video}
        />
        <ExpirationDateModal
          show={this.state.showExpirationDateModal}
          close={this.closeExpirationDateModal}
          sendingId={this.state.sendingId}
          video={video}
        />
      </Grid>
    );
  }
}

CampaignSending.propTypes = {
  video: object,
  updateVideo: func
};

const mapDispatchToProps = dispatch => ({
  updateVideo: (campaignId, video) => {
    dispatch(updateVideo(campaignId, video));
  }
});

export default connect(null, mapDispatchToProps)(CampaignSending);



// WEBPACK FOOTER //
// ./src/components/CampaignSending.js